import { FC, useEffect, useState } from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import {
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  FormHelperText,
  Grid,
  MenuItem,
  Typography,
  Skeleton,
  Divider,
  FormGroup, FormControlLabel,
  Switch,
  OutlinedInput,
  InputAdornment,
  Tooltip,
  ToggleButton,
  ToggleButtonGroup
} from '@material-ui/core';
import LoadingButton from '@material-ui/lab/LoadingButton';
import 'react-loading-skeleton/dist/skeleton.css'
import { InputField } from '../input-field';
import { decisions } from '../../static-data';
import { projectGetMembers } from '../../api/project';
import { stakeholderGetAll } from '../../api/stakeholder';
import { useTranslation } from 'react-i18next';
import { RootState } from '../../store';
import { useDispatch, useSelector } from "react-redux";
import { updateField } from '../../slices/moveSlice';
import { InfoPop } from '../info-pop';

export const WizardGeneral: FC = () => {
  const { t } = useTranslation();
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [users, setUsers] = useState([]);
  const [stakeholders, setStakeholders] = useState([]);

  const move = useSelector((state: RootState) => state.move);
  const dispatch = useDispatch();


  // Colors matching the "Level of Power" scale used in the stakeholder sheet
  const severityColors = {
    0: '#FFF2E6', 1: '#FFE4CC', 2: '#FFCA99', 3: '#FFAF66', 4: '#FF9533', 5: '#FF7A00',
  };

  const getUsers = async () => {
    const _data = await projectGetMembers();
    setUsers(_data);
  }

  const getStakeholders = async () => {
    const res = await stakeholderGetAll('name', 'asc', '', 1, 100);
    if (res.items) {
      setStakeholders(res.items);
    }
  }

  useEffect(() => {
    getUsers();
    getStakeholders();
  }, []);

  const handleSelectedPlan = (event: React.ChangeEvent<HTMLInputElement>, plan: string) => {
    // formik.setFieldValue(plan, event.target.checked);
    // dispatch(updateField())
  };

  return (
    <Card
      // variant="outlined"
      sx={{ backgroundColor: 'background.default' }}
    // {...props}
    >
      <CardContent>
        <Grid
          container
          spacing={4}
        >
          <Grid
            item
            xs={12}
          >
            <div>
              <Grid
                container
                spacing={2}
              >
                {/* <Grid
                    item
                    xs={12}
                    md={8}
                  >
                    <InputField
                      // error={Boolean(formik.touched.name && formik.errors.name)}
                      fullWidth
                      // helperText={formik.touched.name && formik.errors.name}
                      label={t('name')}
                      name="name"
                      // onBlur={formik.handleBlur}
                      onChange={(e) => dispatch(updateField({field: 'name', value: e.target.value}))}
                      value={move.name}
                    />
                  </Grid> */}
                {/* <Grid
                  item
                  xs={12}
                  md={12}
                >
                  <Tooltip title={"The selection of coordinated Tactical Actions for delivering an outcome."} placement={'bottom'} arrow>
                    <FormGroup style={{ marginTop: '20px' }}>
                      <FormControlLabel control={<Switch
                        checked={move.selectedForActionPlan}
                        onChange={(e) => dispatch(updateField({ field: 'selectedForActionPlan', value: e.target.checked }))}
                      />} label={t('selected_for_action_plan')} />
                    </FormGroup>
                  </Tooltip>
                </Grid> */}

                {/* Considered for the following Action Plan (moved from the
                    Planning page). Placed at the top of the first page. */}
                <Grid item xs={12} md={12} sx={{ pb: 0 }}>
                  Considered for the following Action plan to:
                </Grid>
                <Grid item xs={12} md={6} sx={{ pt: '0 !important' }}>
                  <Tooltip title={"The selection of Tactical Actions that are expected to deliver the Definition of Success "} placement={'bottom'} arrow>
                    <FormGroup>
                      <FormControlLabel control={<Switch
                        checked={move.launchPlan}
                        onChange={(e) => {
                          if (e.target.checked === true) {
                            dispatch(updateField({ field: 'launchPlan', value: e.target.checked }));
                            dispatch(updateField({ field: 'reduceUnknownPlan', value: false }));
                          } else {
                            dispatch(updateField({ field: 'launchPlan', value: e.target.checked }));
                            dispatch(updateField({ field: 'reduceUnknownPlan', value: true }));
                          }
                        }}
                      />} label={t('selected_for_launch_plan')} />
                    </FormGroup>
                  </Tooltip>
                </Grid>
                <Grid item xs={12} md={6} sx={{ pt: '0 !important' }}>
                  <Tooltip title={"The selection of Tactical Actions for reducing Unknowns "} placement={'bottom'} arrow>
                    <FormGroup>
                      <FormControlLabel control={<Switch
                        checked={move.reduceUnknownPlan}
                        onChange={(e) => {
                          if (e.target.checked === true) {
                            dispatch(updateField({ field: 'reduceUnknownPlan', value: e.target.checked }));
                            dispatch(updateField({ field: 'launchPlan', value: false }));
                          } else {
                            dispatch(updateField({ field: 'reduceUnknownPlan', value: e.target.checked }));
                            dispatch(updateField({ field: 'launchPlan', value: true }));
                          }
                        }}
                      />} label={t('selected_for_reduce_unknown_plan')} />
                    </FormGroup>
                  </Tooltip>
                </Grid>
                <Grid item xs={12}>
                  <Divider />
                </Grid>

                <Grid
                  item
                  xs={12}
                >
                  <InputField
                    // error={Boolean(formik.touched.descriptionOfTheMove && formik.errors.descriptionOfTheMove)}
                    fullWidth
                    // helperText={formik.touched.descriptionOfTheMove && formik.errors.descriptionOfTheMove}
                    label={t('description_of_the_move')}
                    name="descriptionOfTheMove"
                    // onBlur={formik.handleBlur}
                    onChange={(e) => dispatch(updateField({ field: 'descriptionOfTheMove', value: e.target.value }))}
                    value={move.descriptionOfTheMove}
                    placeholder=""
                    multiline
                    rows={2}
                  />
                </Grid>



                <Grid
                  item
                  xs={12}
                  md={6}
                >
                  <InputField
                    // error={Boolean(formik.touched.decisionForActionPlan && formik.errors.decisionForActionPlan)}
                    fullWidth
                    // helperText={formik.touched.decisionForActionPlan && formik.errors.decisionForActionPlan}
                    label={t('decision_for_action_plan')}
                    name="decisionForActionPlan"
                    // onBlur={formik.handleBlur}
                    onChange={(e) => dispatch(updateField({ field: 'decisionForActionPlan', value: e.target.value }))}
                    select
                    value={move.decisionForActionPlan || 0}
                  >
                    {/* "?" placeholder shown until a recommendation is chosen */}
                    <MenuItem value={0} disabled>
                      ?
                    </MenuItem>
                    {decisions.map((option) => (
                      <MenuItem
                        key={option.value}
                        value={option.value}
                      >
                        {t(option.label)}
                      </MenuItem>
                    ))}
                  </InputField>
                </Grid>

                <Grid
                  item
                  xs={12}
                  md={6}
                >
                  {/* "Retained for final Action Plan" Yes/No toggle (default No) */}
                  <InputField
                    fullWidth
                    label={t('retained_for_action_plan')}
                    name="selectedForActionPlan"
                    onChange={(e) => dispatch(updateField({ field: 'selectedForActionPlan', value: e.target.value === 'yes' }))}
                    select
                    value={move.selectedForActionPlan ? 'yes' : 'no'}
                  >
                    <MenuItem value="no">{t('no')}</MenuItem>
                    <MenuItem value="yes">{t('yes')}</MenuItem>
                  </InputField>
                </Grid>

                <Grid
                  item
                  xs={12}
                >
                  <span style={{
                    fontSize: 12,
                    fontWeight: 500,
                    position: 'relative',
                    transform: 'none',
                    // textDecoration: 'line-through'
                  }}>{t('collateral_effects_action')}</span>
                  <div style={{ display: 'inline-block' }}>
                    <InfoPop
                      infoElementName={t('collateral_effects')}
                      shortText='What is a Collatoral effect?'
                      position='right'
                      longText={'Some of the tactical Actions in your Action Plan may produce collateral effects that could  directly or indirectly upset some of your Stakeholders. You need to identify them in order to anticipate how to manage those negative consequences of your Action Plan (by modifying the Plan to avoid certain Collateral Effects or by preparing a Plan B that mitigates the collateral dammages)'}
                    />
                  </div>
                  <InputField
                    // error={Boolean(formik.touched.collateralEffect && formik.errors.collateralEffect)}
                    fullWidth
                    // helperText={formik.touched.collateralEffect && formik.errors.collateralEffect}
                    // label={t('collateral_effects')}
                    name="collateralEffect"
                    // onBlur={formik.handleBlur}
                    onChange={(e) => dispatch(updateField({ field: 'collateralEffect', value: e.target.value }))}
                    value={move.collateralEffect}
                    multiline
                    rows={2}
                  />
                </Grid>

                {/* Stakeholders impacted by this Collateral effect (chosen from existing stakeholders) */}
                <Grid
                  item
                  xs={12}
                  md={6}
                >
                  <InputField
                    fullWidth
                    label={t('collateral_stakeholder')}
                    name="collateralStakeholder"
                    onChange={(e) => dispatch(updateField({ field: 'collateralStakeholder', value: e.target.value }))}
                    select
                    value={move.collateralStakeholder || ''}
                  >
                    <MenuItem value="">?</MenuItem>
                    {stakeholders.map((s) => (
                      <MenuItem key={s.id} value={s.id}>
                        {s.name}
                      </MenuItem>
                    ))}
                  </InputField>
                </Grid>

                {/* Level of severity of this collateral effect (same color scale as Level of Power) */}
                <Grid
                  item
                  xs={12}
                  md={6}
                >
                  <Typography sx={{ fontSize: 12, fontWeight: 500, mb: 0.5 }}>
                    {t('collateral_severity')}
                  </Typography>
                  <ToggleButtonGroup
                    value={move.collateralSeverity}
                    onChange={(e, val) => { if (val !== null) dispatch(updateField({ field: 'collateralSeverity', value: val })); }}
                    exclusive
                    fullWidth
                    size="small"
                  >
                    <ToggleButton value={-1} sx={{ '&.Mui-selected': { backgroundColor: 'background.paper', color: 'text.primary' }, padding: 0.25, fontSize: '10px', borderTopLeftRadius: '100px', borderBottomLeftRadius: '100px' }}>?</ToggleButton>
                    {[0, 1, 2, 3, 4, 5].map((n) => (
                      <ToggleButton
                        key={n}
                        value={n}
                        sx={{ '&.Mui-selected': { backgroundColor: severityColors[n], color: n >= 4 ? '#FFF' : '#000' }, padding: 0.25, fontSize: '10px', ...(n === 5 ? { borderTopRightRadius: '100px', borderBottomRightRadius: '100px' } : {}) }}
                      >
                        {n}
                      </ToggleButton>
                    ))}
                  </ToggleButtonGroup>
                </Grid>

                {/* Estimated total cost moved to the "Costing of this Action" page. */}

                {/* Start/End dates moved to the Planning page. */}

                {/* {formik.errors.submit && (
                    <Grid
                      item
                      xs={12}
                    >
                      <FormHelperText error>
                        {formik.errors.submit}
                      </FormHelperText>
                    </Grid>
                  )} */}
              </Grid>
            </div>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};